import React from "react";
import { CategorySpend } from "../selectors";
import { formatMoney } from "../format";

interface CategoryBreakdownProps {
    items: CategorySpend[];
    currency: string;
}

const MAX_ROWS = 6;

// One measure across categories: a single hue for every bar, ranked, direct-labeled
export function CategoryBreakdown({ items, currency }: CategoryBreakdownProps) {
    const rows = items.slice(0, MAX_ROWS);
    const rest = items.slice(MAX_ROWS);
    if (rest.length > 0) {
        const amount = rest.reduce((sum, i) => sum + i.amount, 0);
        const share = rest.reduce((sum, i) => sum + i.share, 0);
        rows.push({ category: { id: "other", name: "Other", type: "expense", icon: "•" }, amount, share });
    }
    const max = rows.length > 0 ? rows[0].amount : 0;

    return (
        <section className="fin-card">
            <div className="fin-card-head">
                <h3>Spending by category</h3>
            </div>
            {rows.length === 0 ? (
                <p className="fin-empty">No expenses this month.</p>
            ) : (
                <ul className="fin-categories">
                    {rows.map(({ category, amount, share }) => (
                        <li key={category.id} title={`${category.name}: ${formatMoney(amount, currency)}`}>
                            <span className="fin-cat-name">
                                <span aria-hidden="true">{category.icon}</span> {category.name}
                            </span>
                            <span className="fin-cat-track">
                                <span className="fin-cat-bar" style={{ width: `${Math.max(2, (amount / max) * 100)}%` }} />
                            </span>
                            <span className="fin-cat-value">
                                {formatMoney(amount, currency)} <small>{Math.round(share * 100)}%</small>
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
}
